// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-pagination-frame__Pagination-module--uT5ld {
    display: flex;
    justify-content: center;
    width: fit-content;
    margin-inline: auto;
    background: var(--color-neutral-50);
    border-radius: var(--radius-md);
    padding: var(--space-2xs);
}

.vec-pagination-sticky__Pagination-module--fYm8f {
    position: sticky;
    bottom: var(--space-sm);
    border: 1px solid var(--color-neutral-300);
}

/* base.css's plain-list reset (\`ul:not([class*="ant-"] ul)\`) only excludes a ul/li NESTED inside
   an ant- ancestor, not one that carries the ant- class itself — so it still matches this root
   <ul class="ant-pagination"> and its <li class="ant-pagination-item/-prev/-next/...">, at higher
   specificity than a single scoped class can beat. */
.vec-pagination__Pagination-module--Mg4y0 {
    margin: 0 !important;
    padding-left: 0 !important;
}

.vec-pagination__Pagination-module--Mg4y0 li {
    margin-bottom: 0 !important;
}

.vec-pagination-arrow__Pagination-module--Yoy5T.ant-pagination-item-link {
    display: flex !important;
    align-items: center;
    justify-content: center;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-disabled .vec-pagination-arrow__Pagination-module--Yoy5T {
    color: var(--color-neutral-400);
    opacity: 0.6;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item {
    background: transparent;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item a {
    text-decoration: none;
    font-weight: 600;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-options-size-changer-select .ant-select-content,
.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-options-quick-jumper input {
    font-weight: 600;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item a:hover {
    text-decoration: none;
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item-active {
    background: var(--color-surface-brand);
    border-color: var(--color-surface-brand);
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item-active:hover {
    background: var(--color-surface-brand-strong);
    border-color: var(--color-surface-brand);
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item-active a {
    color: var(--color-text-on-brand);
}

.vec-pagination__Pagination-module--Mg4y0 .ant-pagination-item-active:hover a {
    color: var(--color-text-on-brand);
}
`, "",{"version":3,"sources":["webpack://./vector/src/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;;;qDAGqD;AACrD;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".vec-pagination-frame {\n    display: flex;\n    justify-content: center;\n    width: fit-content;\n    margin-inline: auto;\n    background: var(--color-neutral-50);\n    border-radius: var(--radius-md);\n    padding: var(--space-2xs);\n}\n\n.vec-pagination-sticky {\n    position: sticky;\n    bottom: var(--space-sm);\n    border: 1px solid var(--color-neutral-300);\n}\n\n/* base.css's plain-list reset (`ul:not([class*=\"ant-\"] ul)`) only excludes a ul/li NESTED inside\n   an ant- ancestor, not one that carries the ant- class itself — so it still matches this root\n   <ul class=\"ant-pagination\"> and its <li class=\"ant-pagination-item/-prev/-next/...\">, at higher\n   specificity than a single scoped class can beat. */\n.vec-pagination {\n    margin: 0 !important;\n    padding-left: 0 !important;\n}\n\n.vec-pagination :global(li) {\n    margin-bottom: 0 !important;\n}\n\n.vec-pagination-arrow:global(.ant-pagination-item-link) {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n\n.vec-pagination :global(.ant-pagination-disabled) .vec-pagination-arrow {\n    color: var(--color-neutral-400);\n    opacity: 0.6;\n}\n\n.vec-pagination :global(.ant-pagination-item) {\n    background: transparent;\n}\n\n.vec-pagination :global(.ant-pagination-item a) {\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.vec-pagination :global(.ant-pagination-options-size-changer-select .ant-select-content),\n.vec-pagination :global(.ant-pagination-options-quick-jumper input) {\n    font-weight: 600;\n}\n\n.vec-pagination :global(.ant-pagination-item a:hover) {\n    text-decoration: none;\n}\n\n.vec-pagination :global(.ant-pagination-item-active) {\n    background: var(--color-surface-brand);\n    border-color: var(--color-surface-brand);\n}\n\n.vec-pagination :global(.ant-pagination-item-active:hover) {\n    background: var(--color-surface-brand-strong);\n    border-color: var(--color-surface-brand);\n}\n\n.vec-pagination :global(.ant-pagination-item-active a) {\n    color: var(--color-text-on-brand);\n}\n\n.vec-pagination :global(.ant-pagination-item-active:hover a) {\n    color: var(--color-text-on-brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecPaginationFrame": `vec-pagination-frame__Pagination-module--uT5ld`,
	"vecPaginationSticky": `vec-pagination-sticky__Pagination-module--fYm8f`,
	"vecPagination": `vec-pagination__Pagination-module--Mg4y0`,
	"vecPaginationArrow": `vec-pagination-arrow__Pagination-module--Yoy5T`
};
export default ___CSS_LOADER_EXPORT___;
